import web3 from './web3';
import bep20Abi from "../Abi/bep20Abi.json";
const { REACT_APP_TOKEN_ADDRESS } = process.env
export default new web3.eth.Contract(bep20Abi, REACT_APP_TOKEN_ADDRESS);
